import { useState, useEffect } from 'react';

export const useWatchlist = () => {
  const [watchlist, setWatchlist] = useState(() => {
    try {
      const saved = localStorage.getItem('bingeHQ_watchlist');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      console.error('Failed to parse watchlist from storage:', e);
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('bingeHQ_watchlist', JSON.stringify(watchlist));
    } catch (e) {
      console.error('Failed to save watchlist to storage:', e);
    }
  }, [watchlist]);

  const addToWatchlist = (item, type = 'movie') => {
    setWatchlist(prev => {
      const exists = prev.some(i => i.id === item.id && (i.media_type || type) === (item.media_type || type));
      if (exists) return prev;
      return [{ ...item, media_type: item.media_type || type, addedAt: Date.now() }, ...prev];
    });
  };

  const removeFromWatchlist = (id, type) => {
    setWatchlist(prev => prev.filter(i => !(i.id === id && (type ? (i.media_type === type) : true))));
  };

  const isInWatchlist = (id, type) => {
    return watchlist.some(i => i.id === id && (type ? (i.media_type === type) : true));
  };

  const toggleWatchlist = (item, type = 'movie') => {
    if (isInWatchlist(item.id, item.media_type || type)) {
      removeFromWatchlist(item.id, item.media_type || type);
      return false;
    } else {
      addToWatchlist(item, type);
      return true;
    }
  };

  return {
    watchlist,
    addToWatchlist,
    removeFromWatchlist,
    isInWatchlist,
    toggleWatchlist,
    count: watchlist.length
  };
};
